import { render, staticRenderFns } from "./DdfVoteNewer.vue?vue&type=template&id=67b12ff7&scoped=true&"
import script from "./DdfVoteNewer.vue?vue&type=script&lang=js&"
export * from "./DdfVoteNewer.vue?vue&type=script&lang=js&"
import style0 from "./DdfVoteNewer.vue?vue&type=style&index=0&id=67b12ff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b12ff7",
  null
  
)

export default component.exports